

















import { Component, Vue } from "vue-property-decorator";

import MainNavButton from "@/components/MainNavButton.vue";

@Component({ components: { MainNavButton } })
export default class Home extends Vue {}
